import thunkMiddleware from 'redux-thunk';

import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { rootReducer } from './reducers';

export function configureStore() {
    if (process.env.NODE_ENV === 'development') {
        return createStore(
            rootReducer,
            composeWithDevTools(applyMiddleware(thunkMiddleware))
        );
    }

    return createStore(rootReducer, applyMiddleware(thunkMiddleware));
}
